(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jackets-home-hero"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tawash-jackets-slideshow')) {
  customElements.define('tawash-jackets-slideshow', class extends HTMLElement {
    async connectedCallback() {
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.button = this.querySelector('.ath-jackets-toggle');
      this.slides = Array.from(this.querySelectorAll('.ath-jackets-slide'));
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.visible = false;
      this.hovered = false;
      this.focused = false;
      const loaded = await Promise.all(this.slides.map(async slide => {
        try { await slide.querySelector('img').decode(); return slide; }
        catch { return null; }
      }));
      if (signal.aborted) return;
      this.slides.forEach(slide => {
        slide.classList.remove('is-active');
        slide.setAttribute('aria-hidden', 'true');
      });
      this.slides = loaded.filter(Boolean);
      if (!this.slides.length) return;
      this.index = Math.floor(Math.random() * this.slides.length);
      this.show(this.index);
      if (this.slides.length < 2) return;
      this.button.hidden = false;
      this.updateButton();
      this.button.addEventListener('click', () => {
        this.paused = !this.paused;
        this.updateButton();
        this.schedule();
      }, { signal });
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, { signal });
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, { signal });
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, { signal });
      this.addEventListener('focusout', event => {
        this.focused = this.contains(event.relatedTarget);
        this.schedule();
      }, { signal });
      document.addEventListener('visibilitychange', () => this.schedule(), { signal });
      this.motion.addEventListener('change', event => {
        if (event.matches) this.paused = true;
        this.updateButton();
        this.schedule();
      }, { signal });
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.schedule();
      });
      this.observer.observe(this);
    }
    show(index) {
      this.index = index;
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
        slide.setAttribute('aria-hidden', String(i !== index));
      });
    }
    updateButton() {
      this.button.classList.toggle('is-paused', this.paused);
      this.button.setAttribute('aria-label', this.paused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel);
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.paused || !this.visible || this.hovered || this.focused || document.hidden || !this.isConnected) return;
      this.timer = setTimeout(() => {
        const offset = 1 + Math.floor(Math.random() * (this.slides.length - 1));
        this.show((this.index + offset) % this.slides.length);
        this.schedule();
      }, 5000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
